import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { BlockTextboxComponent } from '@app/components/blocks/block-textbox/block-textbox.component';
import { PlInputModule } from '@app/components/pl-input/pl-input.module';

@NgModule({
  imports: [CommonModule, SharedModule, ReactiveFormsModule, PlInputModule],
  declarations: [BlockTextboxComponent],
  exports: [BlockTextboxComponent],
})
export class BlockTextboxModule {}
